import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-smtp-mailbox-lookup',
  templateUrl: './micro-smtp-mailbox-lookup.component.html'
})
export class MicroSmtpMailboxLookupComponent  {

  @Input()
  smtpMailboxId:any;

  @Input()
  link:boolean = true;
}
